/** @jsx jsx */
import { jsx } from '@emotion/core';
import {
  createStyles,
  makeStyles,
  Theme,
  Typography,
  useTheme,
} from '@material-ui/core';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    text: {
      fontWeight: 700,
      fontFamily: 'Untitled-Sans',
      margin: theme.spacing(0, 0, 3, 0),
      [`@media (min-width: ${theme.breakpoints.values.sm}px)`]: {
        fontSize: '20px',
      },
    },
  }),
);

export function SectionInfo({ text }: { text?: string }) {
  const classes = useStyles();
  return (
    <Typography className={classes.text} variant="h4">
      {text}
    </Typography>
  );
}
